export default {"src":"/_next/static/media/record.eeeeed85.svg","height":844,"width":1057,"blurWidth":0,"blurHeight":0};